import _extends from "@babel/runtime/helpers/extends";
import { Fragment } from "react";
import { useBanner } from "../../contexts";
import { BannerDottedGroups, BannerBodyInlineStyles, BannerInlineStyles, BannerButtons, BannerGroups, BannerHistorySelect } from ".";
import { usePlainCss } from "../../hooks";
import { expandGroupsServiceVariable } from "../../others";

var BannerBody = function BannerBody() {
  var banner = useBanner();
  var groups = banner.groups,
      type = banner.layout.type,
      isEPrivacyUSA = banner.ePrivacyUSA,
      isAgeNotice = banner.ageNotice,
      _banner$texts = banner.texts,
      description = _banner$texts.description,
      ePrivacyUSA = _banner$texts.ePrivacyUSA,
      ageNoticeBanner = _banner$texts.ageNoticeBanner,
      individualPrivacyOpen = banner.individualPrivacyOpen,
      individualTexts = banner.individualTexts,
      activeAction = banner.activeAction; // Make the content responsive

  var leftSideId = "bnnr-body-leftSide-".concat(banner.pageRequestUuid4);
  var rightSideId = "bnnr-body-rightSide-".concat(banner.pageRequestUuid4);
  usePlainCss("@media only screen and (max-width: 650px)  {\n #".concat(leftSideId, " {\n  float: initial !important;\n  width: auto !important;\n  padding-right: initial !important;\n  ").concat(type === "banner" && !individualPrivacyOpen ? "padding-bottom: 10px !important;" : individualPrivacyOpen ? "padding-top: 10px !important;" : "", "\n }\n \n #").concat(rightSideId, " {\n  float: initial !important;\n  width: auto !important;\n  max-width: initial !important;\n  margin: initial !important;\n  ").concat(individualPrivacyOpen ? "padding-bottom: 5px !important;" : "padding-top: 10px !important;", "\n  position: sticky;\n }\n}"));
  var useDescription = individualPrivacyOpen ? individualTexts.description : description;
  var useEPrivacyUSA = expandGroupsServiceVariable(groups, isEPrivacyUSA ? ePrivacyUSA : "", function (_ref) {
    var ePrivacyUSA = _ref.ePrivacyUSA;
    return ePrivacyUSA;
  }, 3, true);
  var leftSide = h("div", _extends({
    key: "leftSide",
    id: leftSideId
  }, BannerInlineStyles.leftSide(banner)), !!useDescription && h(Fragment, null, h("div", BannerBodyInlineStyles.description(banner), activeAction === "history" ? h(BannerHistorySelect, null) : h(Fragment, null, h("span", {
    dangerouslySetInnerHTML: {
      __html: useDescription
    }
  }), (isEPrivacyUSA || isAgeNotice) && h(Fragment, null, h("div", null, h("span", BannerBodyInlineStyles.teachingsSeparator(banner))), !!useEPrivacyUSA && h("span", _extends({}, BannerBodyInlineStyles.teaching(banner), {
    dangerouslySetInnerHTML: {
      __html: useEPrivacyUSA
    }
  })), isAgeNotice && !!ageNoticeBanner && h("span", _extends({}, BannerBodyInlineStyles.teaching(banner), {
    dangerouslySetInnerHTML: {
      __html: ageNoticeBanner
    }
  })))))), individualPrivacyOpen ? h(BannerGroups, null) : h(BannerDottedGroups, null));
  var rightSide = activeAction === "history" ? h("div", null) : h("div", _extends({
    key: "rightSide",
    id: rightSideId
  }, BannerInlineStyles.rightSide(banner)), h(BannerButtons, null));
  return h("div", BannerBodyInlineStyles.bodyContainer(banner), h("div", BannerBodyInlineStyles.body(banner), individualPrivacyOpen ? [rightSide, leftSide] : [leftSide, rightSide], h("div", {
    style: {
      clear: "both"
    }
  })));
};

export { BannerBody };